module.exports = __webpack_public_path__ + "img/30689848000130.a56e05e0.png";